import React from "react";

const About = () => {
  return (
    <section
      id="about"
      className="py-20 px-6 bg-white relative overflow-hidden"
    >
      {/* Background Abstract Shapes */}
      <div className="absolute top-0 left-0 w-full h-full opacity-20 z-0"></div>
      <div className="absolute top-0 right-0 w-full h-full opacity-20 z-0"></div>

      <div className="container mx-auto relative z-10 flex flex-col lg:flex-row items-start lg:space-x-16">
        {/* Content Section */}
        <div className="w-full lg:w-1/2 pr-8">
          <h2 className="text-4xl md:text-5xl font-extrabold text-primary mb-6">
            About Us
          </h2>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6 text-justify">
            At Arancia, we are driven by a passion to empower businesses through
            tailored Odoo solutions that enhance efficiency and support growth.
            While we are a newly established company, our foundation is built on
            the extensive expertise of seasoned IT professionals with decades of
            experience in ERP implementations and cutting-edge software
            development.
          </p>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6 text-justify">
            Our leadership team brings nearly 80 years of collective IT
            expertise, having successfully worked in similar domains and across
            diverse industries. As we build Arancia’s foundation, we are
            assembling a dynamic team that shares our commitment to delivering
            excellence.
          </p>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6 text-justify">
            We specialize in the implementation and optimization of Odoo
            modules, helping businesses streamline operations across areas such
            as accounting, inventory, CRM, HR, and more. Our approach emphasizes
            high coding standards, adaptability, and scalability to meet your
            unique needs.
          </p>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed text-justify">
            At Arancia, we’re not just building systems—we’re building
            partnerships and helping businesses lay the foundation for long-term
            success. Let us work with you to unlock the full potential of Odoo
            and transform your business into an agile, efficient, and
            future-ready enterprise.
          </p>
        </div>

        {/* Right Side - Image Section */}
        <div className="w-full lg:w-1/2 flex justify-center items-center">
          <img
            src="/about-image.png"
            alt="Empowering businesses with Odoo"
            className="rounded-lg shadow-lg w-full max-w-md mt-8"
          />
        </div>
      </div>
    </section>
  );
};

export default About;
